// professional-profile.page.ts
import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { AppHeaderComponent } from '@ui/app-header/app-header.component';
import { SuccessNotificationCardComponent } from '@ui/success-notification-card/success-notification-card.component';

@Component({
  selector: 'app-professional-profile-page',
  standalone: true,
  imports: [CommonModule, FormsModule, AppHeaderComponent, SuccessNotificationCardComponent],
  templateUrl: './professional-profile.page.html',
  styleUrls: ['./professional-profile.page.scss']
})
export class ProfessionalProfilePageComponent implements OnInit {
  private auth = inject(AuthService);
  private location = inject(Location);
  private cdr = inject(ChangeDetectorRef);

  userData = {
    firstname: '',
    lastname: '',
    phone: '',
    dni: ''
  };

  editData = {
    firstname: '',
    lastname: '',
    phone: ''
  };

  showEditModal = false;
  showSuccessMessage = false;
  successTitle = '¡Cambios guardados!';
  successSubtitle = 'La acción se realizó con éxito'; 

  ngOnInit(): void {
    const user = this.auth.user();
    if (user) {
      this.userData.firstname = user.firstname || user.name?.split(' ')[0] || '';
      this.userData.lastname = user.lastname || user.name?.split(' ').slice(1).join(' ') || '';
      this.userData.phone = String(user.phone_number || '');
      this.userData.dni = user.dni || '';
    }
  }

  goBack(): void {
    this.location.back();
  }

  openEditModal(): void {
    // Copiar datos actuales al objeto de edición
    this.editData = {
      firstname: this.userData.firstname,
      lastname: this.userData.lastname,
      phone: this.userData.phone
    };
    this.showEditModal = true;
  }

  closeEditModal(): void {
    this.showEditModal = false;
  }

  onPhoneInputChange(event: any): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    
    // Filtrar solo números y limitar a 9 dígitos
    const filtered = value.replace(/\D/g, '').slice(0, 9);
    
    // Actualizar el valor del input y el modelo
    input.value = filtered;
    this.editData.phone = filtered;
  }

  async saveChanges(): Promise<void> {
    try {
      // Llamar al servicio para actualizar el perfil
      const updatedUser = await this.auth.updateUserProfile({
        firstname: this.editData.firstname,
        lastname: this.editData.lastname,
        phone_number: this.editData.phone
      });

      if (updatedUser) {
        // Cerrar el modal
        this.closeEditModal();
        
        // Actualizar los datos locales
        this.userData.firstname = updatedUser.firstname || updatedUser.name?.split(' ')[0] || '';
        this.userData.lastname = updatedUser.lastname || updatedUser.name?.split(' ').slice(1).join(' ') || '';
        this.userData.phone = String(updatedUser.phone_number || '');
        
        // Mostrar mensaje de éxito
        this.showSuccessMessage = true;
        this.cdr.detectChanges();
      }
    } catch (error) {
      console.error('Error al guardar cambios:', error);
      alert('Error al actualizar el perfil. Por favor, inténtalo de nuevo.');
    }
  }

  onSuccessClose(): void {
    this.showSuccessMessage = false;
  }
}
